import React from "react";
import { Reveal, SectionHeading } from "./Atoms";

const STATS = [
  ["40+", "States", "Prophet Dishawn has traveled and preached across America carrying the Gospel and the fire of revival."],
  ["16", "Years & Counting", "Dishawn and Michelle stand together in covenant, family, and ministry."],
  ["4", "Amazing Children", "Building family, legacy, and ministry together."],
  ["National", "Revival Mandate", "Commissioned by God to host tent revivals, crusades, gatherings, and revival events across the nation."],
  ["Global", "Mandate", "Awakening hearts, restoring families, equipping believers, and calling God's creation back to Himself."],
];

const Leadership = () => {
  return (
    <section id="leadership" className="relative py-28 px-6 section-ember overflow-hidden">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-14 items-center">
        {/* Portrait */}
        <div className="lg:col-span-6 order-2 lg:order-1">
          <Reveal>
            <div className="relative">
              <div className="absolute -inset-4 rounded-[28px] bg-gradient-to-br from-[#C9A44C]/30 via-transparent to-[#E8452C]/20 blur-2xl opacity-60" aria-hidden="true" />
              <div className="relative aspect-[4/5] rounded-[24px] overflow-hidden border border-[#C9A44C]/30 bg-[#0a0a0a]">
                <img
                  src="https://customer-assets.emergentagent.com/job_revival-fire-hub/artifacts/mwahxlcj_b303ac32-b234-40ad-908b-9e0681db420f__1_.png"
                  alt="Prophet Dishawn S. Gordon and Prophetess Michelle Smith Gordon"
                  className="absolute inset-0 w-full h-full object-cover"
                  data-testid="leadership-portrait"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-transparent to-transparent" />
                <div className="absolute bottom-6 left-6 right-6">
                  <div className="overline mb-1">Covenant Leaders</div>
                  <div className="font-serif-display text-2xl sm:text-3xl text-[#F6F0E6] leading-tight">
                    Prophet Dishawn S. Gordon
                    <div className="text-[#C9A44C] italic text-xl sm:text-2xl">& Prophetess Michelle Smith Gordon</div>
                  </div>
                </div>
              </div>
            </div>
          </Reveal>
        </div>

        {/* Content */}
        <div className="lg:col-span-6 order-1 lg:order-2">
          <Reveal>
            <SectionHeading
              overline="Covenant Leaders"
              title={<>Carrying the <span className="italic gold-text">Mandate</span> of Revival</>}
            />
          </Reveal>
          <Reveal delay={80}>
            <p className="text-[#D9D9D9] text-base sm:text-[17px] leading-relaxed">
              Prophet Dishawn S. Gordon and Prophetess Michelle Smith Gordon are covenant
              leaders carrying a mandate for revival, holiness, restoration, and the fire
              of the Holy Ghost.
            </p>
          </Reveal>
          <Reveal delay={140}>
            <p className="mt-4 text-[#D9D9D9] text-base sm:text-[17px] leading-relaxed">
              Before meeting his wife, Prophet Dishawn had already traveled and preached
              across <span className="text-[#F6F0E6]">40+ states</span>, carrying the Gospel
              and the fire of revival throughout America. Through ministry, he met
              Prophetess Michelle, and together they began walking in covenant, family,
              and the work of revival. Now married <span className="text-[#F6F0E6]">16 years and counting</span>,
              they stand together as leaders of Revival Fire Ministries Global and proud
              parents of <span className="text-[#F6F0E6]">four amazing children</span>.
            </p>
          </Reveal>
          <Reveal delay={200}>
            <p className="mt-4 text-[#D9D9D9] text-base sm:text-[17px] leading-relaxed">
              God has commissioned them to host tent revivals, crusades, gatherings, and
              revival events across the nation — calling cities, regions, and families
              back to Jesus Christ through repentance, holiness, deliverance, healing,
              discipleship, evangelism, and the fire of the Holy Ghost.
            </p>
          </Reveal>
        </div>
      </div>

      {/* Stat strip */}
      <div className="max-w-7xl mx-auto mt-20 grid grid-cols-2 md:grid-cols-5 border-t border-b border-[#C9A44C]/20 divide-x divide-[#C9A44C]/20">
        {STATS.map(([v, l, d], i) => (
          <Reveal key={i} delay={i * 70}>
            <div className="px-6 py-8 text-center h-full flex flex-col items-center" data-testid={`stat-${i}`}>
              <div className="font-serif-display text-4xl sm:text-5xl gold-text">{v}</div>
              <div className="mt-1 text-[11px] tracking-[0.22em] uppercase text-[#C9A44C]">{l}</div>
              <p className="mt-3 text-xs sm:text-[13px] text-[#D9D9D9] leading-relaxed">{d}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};

export default Leadership;
